module.exports = __webpack_public_path__ + "static/media/white-refresh-icon-16x16.ea217267.svg";